(() => {
  const videos = document.querySelectorAll('[data-tinhao-lazy-story-video]');
  if (!videos.length) return;

  const connection = navigator.connection || navigator.mozConnection || navigator.webkitConnection;
  const saveData = Boolean(connection?.saveData);
  const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  videos.forEach((video) => {
    video.controls = false;
    video.disablePictureInPicture = true;
  });

  const attachSource = (video) => {
    if (video.dataset.sourceAttached === 'true') return;
    video.src = video.dataset.videoSrc;
    video.dataset.sourceAttached = 'true';
  };

  const playVideo = (video) => {
    attachSource(video);
    video.play().catch(() => {});
  };

  if (saveData || reducedMotion) {
    // Keep the lightweight poster visible without exposing native video controls.
    return;
  }

  const preloadObserver = new IntersectionObserver((entries, observer) => {
    entries.forEach((entry) => {
      if (!entry.isIntersecting) return;
      attachSource(entry.target);
      observer.unobserve(entry.target);
    });
  }, { rootMargin: '600px 0px', threshold: 0 });

  const playbackObserver = new IntersectionObserver((entries) => {
    entries.forEach((entry) => {
      if (entry.isIntersecting) playVideo(entry.target);
      else entry.target.pause();
    });
  }, { threshold: 0.15 });

  videos.forEach((video) => {
    preloadObserver.observe(video);
    playbackObserver.observe(video);
  });

  document.addEventListener('visibilitychange', () => {
    if (document.hidden) videos.forEach((video) => video.pause());
  });
})();
